<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.snackbar"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div v-if="selected !== 'key'">
                  Terima kasih, Anda berhasil menyimpan konfigurasi <span v-if="selected === 'ppn'">PPN</span><span v-else-if="selected === 'footer'">Footer Printer</span><span v-else-if="selected === 'logo'">Logo Printer</span><span v-else>Nominal Stok</span>
                </div>
                <div v-else>
                  Terima kasih, Anda berhasil generate key
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.konfirmasi"
          @keydown.esc="dialog.konfirmasi = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.konfirmasi = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              <span v-if="selected === 'ppn'">
                <span>
                  Apakah Anda yakin ingin mengubah konfigurasi PPN pada transaksi pembelian?
                </span>
              </span>
              <span v-else-if="selected === 'footer'">
                <span>
                  Apakah Anda yakin ingin mengubah konfigurasi footer printer?
                </span>
              </span>
              <span v-else-if="selected === 'logo'">
                <span>
                  Apakah Anda yakin ingin mengubah konfigurasi logo printer?
                </span>
              </span>
              <span v-else-if="selected === 'key'">
                <span>
                  Apakah Anda yakin ingin generate key?
                </span>
              </span>
              <span v-else>
                <span>
                  Apakah Anda yakin ingin mengubah konfigurasi menampilkan nominal stok?
                </span>
              </span>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.konfirmasi = false; dialog.fullscreen = false;"
                :disabled="process.form"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Konfigurasi Outlet
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1 pt-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <div class="view">
                    <div :class="'wrapper'">
                      <table style="border: 1px solid #ededed; width: 100%;" class="table">
                        <tr>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color};`">Konfigurasi</th>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color};`">Konfigurasi</th>
                        </tr>
                        <tr>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">
                            <div>
                              Konfigurasi Hitung PPN pada Transaksi Pembelian
                            </div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; padding: 8px 12px; text-align: left;">
                            <div>
                              <v-select
                                v-model="form.is_count_ppn"
                                :items="[
                                  { text: 'PPN Dihitung', value: true },
                                  { text: 'PPN Tidak Dihitung', value: false }
                                ]"
                                item-text="text"
                                item-value="value"
                                hide-details
                                outlined
                                dense
                                elevation="0"
                                :disabled="process.form"
                                :color="set_color"
                                style="width: 200px;"
                                class="fs-12 little-placeholder"
                                v-on:change="message.error = ''; selected = 'ppn'; dialog.konfirmasi = true;">
                              </v-select>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">
                            <div>
                              Logo Outlet
                            </div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; padding: 8px 12px; text-align: left;">
                            <div>
                              <uploadfolder
                                v-model="upload.logo" 
                                style="height: 200px; width: 200px">
                                <div 
                                  slot="activator"
                                  class="cursor-pointer">
                                  <v-card 
                                    flat
                                    height="200"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <div v-if="form.logo_url.length < 1">
                                      <v-icon v-if="!process.logo"
                                        size="60" 
                                        color="#718EBF">
                                        mdi-cloud-upload-outline
                                      </v-icon>
              
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
              
                                    <v-img v-else
                                      contain
                                      height="200"
                                      :src="form.logo_url" 
                                      :alt="form.logo_url"
                                      class="text-center d-flex align-center">
                                      <div 
                                        class="d-flex aling-center justify-center" 
                                        style="width: 100%; height: auto;">
                                        <v-icon v-if="!process.logo"
                                          size="60" 
                                          color="white">
                                          mdi-cloud-upload-outline
                                        </v-icon>
              
                                        <v-progress-circular v-else
                                          indeterminate
                                          :color="set_color">
                                        </v-progress-circular>
                                      </div>
                                    </v-img>
                                  </v-card>
                                </div>
                              </uploadfolder>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">
                            <div>
                              Konfigurasi Footer Printer
                            </div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; padding: 8px 12px; text-align: left;">
                            <div>
                              <v-textarea
                                v-model="form.footer"
                                outlined
                                dense
                                rows="3"
                                :disabled="process.form"
                                :color="set_color"
                                hide-details
                                class="fs-12"
                                v-on:keydown.enter.prevent="message.error = ''; selected = 'footer'; dialog.konfirmasi = true;"
                                v-on:change="message.error = ''; selected = 'footer'; dialog.konfirmasi = true;">
                              </v-textarea>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">
                            <div>
                              Konfigurasi Menampilkan Nominal Stok
                            </div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; padding: 8px 12px; text-align: left;">
                            <div>
                              <v-select
                                v-model="form.is_stock_displayed"
                                :items="[
                                  { text: 'Stok Tampil', value: true },
                                  { text: 'Stok Tidak Tampil', value: false }
                                ]"
                                item-text="text"
                                item-value="value"
                                hide-details
                                outlined
                                dense
                                elevation="0"
                                :disabled="process.form"
                                :color="set_color"
                                style="width: 200px;"
                                class="fs-12 little-placeholder"
                                v-on:change="message.error = ''; selected = 'stok'; dialog.konfirmasi = true;">
                              </v-select>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;">
                            <div>
                              Key ID
                            </div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; padding: 8px 12px; text-align: left;">
                            <div v-if="form.key !== ''">
                              <span id="testing-code">https://ecatalog.amanata.co/outlet/{{ form.key }}</span>
                              <v-btn
                                rounded
                                @click="copyTestingCode()"
                                icon
                                class="body-2 font-weight-bold text-capitalize ml-2">
                                <v-icon size="18">mdi-content-copy</v-icon>
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                @click="message.error = ''; selected = 'key'; dialog.konfirmasi = true;"
                                :disabled="process.form || process.load"
                                :color="set_color"
                                elevation="0"
                                class="body-2 font-weight-bold text-capitalize white--text">
                                Generate Key
                              </v-btn>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <!-- <div>
                    <v-switch
                      v-model="form.is_count_ppn"
                      inset
                      :disabled="process.form"
                      :color="set_color"
                      style="width: fit-content;"
                      v-on:change="message.error = ''"
                    >
                    <template v-slot:label>
                      <div class="black--text" style="font-weight: 500;">
                        {{ form.is_count_ppn ? 'PPN Dihitung' : 'PPN Tidak Dihitung' }} pada Transaksi Pembelian
                      </div>
                    </template>
                    </v-switch>
                  </div> -->

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          konfirmasi: false
        },
        selected: '',
        detail: {},

        upload: {
          logo: null
        },

        unit: [],

        form: {
          is_count_ppn: true,
          footer: '',
          is_stock_displayed: true,
          logo_url: '',
          key: ''
        },
        process: {
          load: false,
          form: false,

          doc: false,
          logo: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.logo': {
        handler: function () {
          if (this.upload.logo) {
            this.process.logo = this.upload.logo.process

            if (!this.process.logo) {
              // CALLBACK FROM UPLOAD logo
              
              this.form.logo_url = this.upload.logo.fileuri
              setTimeout(() => {
                this.message.error = ''; 
                this.selected = 'logo'; 
                this.dialog.konfirmasi = true;
              }, 1200)

              // this.save_image()
            }
          }
        },
        deep: true
      },
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      outlet () {
        return this.$store.state.outlet
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.outlet.outlet_id
        }

        await get(`pos/outlet/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail = res.results.data
            this.form.is_count_ppn = this.detail.is_count_ppn === '1' ? true : false
            this.form.is_stock_displayed = this.detail.is_stock_displayed === '1' ? true : false
            this.form.footer = this.detail.footer === null ? '' : this.detail.footer
            this.form.logo_url = this.detail.logo_url
            this.form.key = this.detail.key
            let user = this.$store.state.user
            user.is_count_ppn = this.detail.is_count_ppn
            user.footer = this.detail.footer
            user.is_stock_displayed = this.detail.is_stock_displayed
            user.logo_url = this.detail.logo_url
            TokenService.saveToken(
                this.$store.state.token,
                JSON.stringify(user),
                JSON.stringify(this.$store.state.menu)
              )
              // console.log(user)

              this.$store.state.user = user

              this.process.load = false
            }
        })
      },
      async copyTestingCode() {
        let text = `https://ecatalog.amanata.co/outlet/`+this.form.key
        try {
          await navigator.clipboard.writeText(text);
          alert('Data berhasil dicopy ');
        } catch (err) {
          alert('Data tidak berhasil dicopy ');
        }
      },
      // copyTestingCode () {
      //   let testingCodeToCopy = document.querySelector('#testing-code')
      //   testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
      //   testingCodeToCopy.select()

      //   try {
      //     var successful = document.execCommand('copy');
      //     var msg = successful ? 'successful' : 'unsuccessful';
      //     alert('Testing code was copied ' + msg);
      //   } catch (err) {
      //     alert('Oops, unable to copy');
      //   }

      //   /* unselect the range */
      //   testingCodeToCopy.setAttribute('type', 'hidden')
      //   window.getSelection().removeAllRanges()
      // },
      async save () {
        this.process.form = true
        this.message.error = ''
        let url = this.selected === 'ppn' ? 'pos/outlet/config_ppn' : this.selected === 'footer' ? 'pos/outlet/config_printer_footer' : this.selected === 'logo' ? 'pos/outlet/config_logo' : this.selected === 'key' ? 'pos/outlet/config_key' : 'pos/outlet/config_stock',
        data_form = this.selected === 'ppn' ? 
            {
              outlet_id: this.outlet.outlet_id,
              is_count_ppn: this.form.is_count_ppn === true ? '1' : '0'
            } :
            this.selected === 'footer' ? 
            {
              outlet_id: this.outlet.outlet_id,
              footer: this.form.footer
            } : this.selected === 'logo' ? 
            {
              outlet_id: this.outlet.outlet_id,
              logo_url: this.form.logo_url
            } : this.selected === 'key' ? 
            {
              outlet_id: this.outlet.outlet_id
            } :
            {
              outlet_id: this.outlet.outlet_id,
              is_stock_displayed: this.form.is_stock_displayed === true ? '1' : '0'
            }

          // SAVE TO REST API
        await post(`${url}`, {
          data: data_form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            let user = this.$store.state.user
            if(this.selected === 'ppn') {
              user.is_count_ppn = this.form.is_count_ppn === true ? '1' : '0'
            } else if(this.selected === 'footer') {
              user.footer = this.form.footer
            } else if(this.selected === 'logo') {
              user.logo_url = this.form.logo_url
            } else {
              user.is_stock_displayed = this.form.is_stock_displayed === true ? '1' : '0'
            }

            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(user),
              JSON.stringify(this.$store.state.menu)
            )
            // console.log(user)

            this.$store.state.user = user

            this.dialog.snackbar = true
            this.dialog.konfirmasi = false
            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>